// Branding / theme defaults (overridden by CMS)
export const BRANDING = {
  brand_name: "places",
  brand_accent_char: ".", // dot after the wordmark
  brand_accent_color: "#FF5E00",
  logo_url: "", // empty = use textual wordmark
  logo_url_dark: "", // optional inverted logo for dark sections
  logo_height: 40,
  marquee_speed_seconds: 40, // services marquee (lower = faster)
  testimonials_speed_seconds: 60, // home testimonials marquee
  blob_animation_speed_seconds: 24, // background blob drift speed (lower = faster)
  accent_yellow: "#D4FF00",
  accent_orange: "#FF5E00",
  accent_green: "#00E59B",
  favicon_url: "",
};

export const ANALYTICS = {
  ga4_id: "",          // e.g. G-XXXXXXXXXX
  gtm_id: "",          // e.g. GTM-XXXXXXX
  meta_pixel_id: "",   // e.g. 1234567890
  tiktok_pixel_id: "",
  linkedin_partner_id: "",
  hotjar_id: "",
  clarity_id: "",
  custom_head_html: "",  // raw HTML appended to <head>
  custom_body_html: "",  // raw HTML appended at end of <body>
};

export const FOOTER_CONFIG = {
  labels: {
    menu: "Menu", offices: "Unidades", ecosystem: "Ecossistema",
    social: "Social", legal: "Política de Privacidade",
    rights: "Todos os direitos reservados.",
  },
  copyright_extra: "CNPJ 00.000.000/0001-00",
  tagline_override: "", // empty = use SITE.tagline
};

export const ECOSYSTEM = [
  { name: "Google Partner", url: "https://www.google.com/partners/" },
  { name: "Meta Business", url: "https://www.facebook.com/business" },
  { name: "ABMI", url: "" },
];

export const PRESENCE_EXTENDED = {
  active: ["GO", "MT", "DF", "SP", "RJ", "MG", "BA", "PR", "SC"],
  past: ["RS", "PE", "CE", "ES", "PA", "AM", "TO", "MS", "MA"],
  international: ["Argentina", "Paraguai", "Uruguai", "Portugal"],
};

export const UTM_TEMPLATES = [
  { name: "Instagram Stories — Lançamento", source: "instagram", medium: "social", campaign: "lancamento", content: "stories" },
  { name: "Meta Ads — Performance", source: "meta", medium: "paid-social", campaign: "performance", content: "feed" },
  { name: "Google Ads — Search", source: "google", medium: "cpc", campaign: "search", content: "brand" },
];

// Sobre page editable copy (overridden by CMS).
export const SOBRE = {
  hero_eyebrow: "Sobre · The Real Estate Legacy",
  hero_title_html: "Um legado <em class=\"not-italic text-accent-orange\">imobiliário</em>.",
  hero_subtitle: "Construído por mais de três décadas ao lado das maiores incorporadoras do Brasil — com método próprio, time multidisciplinar e parceria oficial Google.",
  hero_video_poster: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  hero_video_url: "",
  manifesto_title_html: "O imóvel na planta é, antes de tudo, <span class=\"text-accent-orange\">sonho</span>, projeção e percepção de valor.",
  manifesto_paragraph: "Por isso, nosso método combina ciência e arte: dados de mercado para reduzir o risco, e narrativa de marca para gerar o desejo.",
  manifesto_hashtag: "#ApaixonadosPorImobiliario",
  pillars_eyebrow: "Nosso Método",
  pillars_title: "Quatro pilares da Construção de Valor do Lugar.",
  team_title: "O time.",
  team_footnote: "+22 colaboradores em Goiânia, Cuiabá e Brasília.",
  founders_title: "Fundadores",
  reasons_title: "Por que escolher a Places?",
  history_title: "Histórico de projetos.",
  history_subtitle: "Mais de 300 lançamentos em 17 estados. Filtre por ano ou busque por palavra-chave.",
};

// Three featured videos rendered below the main about video (CMS-editable).
export const SOBRE_VIDEOS = [
  { title: "Construção de Marca", poster: "https://images.unsplash.com/photo-1521737711867-e3b97375f902?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", url: "" },
  { title: "Elaboração de Produto", poster: "https://images.unsplash.com/photo-1497366216548-37526070297c?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", url: "" },
  { title: "Performance Digital", poster: "https://images.unsplash.com/photo-1551434678-e076c223a692?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", url: "" },
];

// Horizontal testimonials marquee on the home (before final CTA).
export const TESTIMONIALS = [
  { author: "Carlos Aguiar", role: "Diretor", company: "Construtora Aguiar", photo: "", text: "A Places não só entendeu o produto — ela o reposicionou para o mercado." },
  { author: "Marina Castro", role: "CMO", company: "Castro Empreendimentos", photo: "", text: "Trabalham com método. Em 90 dias, dobramos o ritmo de vendas." },
  { author: "André Lemos", role: "CEO", company: "Lemos Incorporações", photo: "", text: "São parceiros estratégicos. Não tratam o briefing como pedido — tratam como missão." },
];

// 4 thumbnails (16:9) on the "We are PLACES" section
export const WE_ARE_THUMBNAILS = [
  { src: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920", alt: "Equipe Places", link: "" },
  { src: "https://images.unsplash.com/photo-1497366216548-37526070297c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920", alt: "Estúdio", link: "" },
  { src: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920", alt: "Reunião", link: "" },
  { src: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920", alt: "Apresentação", link: "" },
];

// Contato page extras (CMS-editable).
export const CONTACT_EXTRAS = {
  google_maps_embed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3819.0!2d-49.2643!3d-16.6864!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0:0x0!2zMTbCsDQxJzExLjAiUyA0OcKwMTUnNDcuNSJX!5e0!3m2!1spt-BR!2sbr!4v0!5m2!1spt-BR!2sbr",
  facade_image_1: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  facade_image_2: "https://images.unsplash.com/photo-1554995207-c18c203602cb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  facade_caption_1: "Sede Places · Goiânia",
  facade_caption_2: "Recepção e atelier criativo",
};

// Author bios for insight posts (matched by lowercase name).
export const AUTHOR_BIOS = [
  { name: "Pedro Henrique", role: "CEO & Founder · Places", bio: "Mais de 20 anos liderando agências para o mercado imobiliário. Especialista em estratégia e crescimento.", linkedin: "https://linkedin.com/in/pedrohenrique", photo: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&q=85&w=400" },
  { name: "Heitor Lima", role: "CCO · Places", bio: "Diretor criativo premiado com foco em branding imobiliário e narrativa de marca para empreendimentos.", linkedin: "https://linkedin.com/in/heitorlima", photo: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=srgb&fm=jpg&q=85&w=400" },
];

// Remuneration options for services (CMS-editable list).
export const REMUNERATION_OPTIONS = ["Fixo + variável", "Preço Fixo", "Variável"];

// SEO global defaults (overridden by cms_kv.seo). CMS: /admin/seo
export const SEO_DEFAULTS = {
  site_name: "Places",
  site_url: "https://agenciaplaces.com.br",
  title_template: "%s | Places",
  default_title: "Places · Real Estate Marketing Agency",
  default_description: "Agência de marketing imobiliário especializada em incorporadoras. Estratégia, branding, performance digital e placemaking desde 1993.",
  default_og_image: "",
  default_keywords: ["marketing imobiliário", "incorporadoras", "branding imobiliário", "lançamento imobiliário", "performance digital"],
  default_robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
  organization_name: "Places",
  organization_logo: "",
  publisher: "Places",
  twitter_handle: "",
  twitter_card: "summary_large_image",
  social_urls: [],
  enable_jsonld_org: true,
  enable_jsonld_website: true,
  google_site_verification: "",
  bing_site_verification: "",
  facebook_domain_verification: "",
  pinterest_site_verification: "",
  yandex_verification: "",
  robots_txt: "",
};
export const CERTIFICATIONS = [
  { name: "Google Partner", logo: "https://upload.wikimedia.org/wikipedia/commons/2/2d/Google-Partner-Badge.png", url: "https://www.google.com/partners/", description: "Parceria oficial Google" },
  { name: "RD Station Partner", logo: "https://cdn.brandfetch.io/idAOTdBv2Z/w/512/h/512/theme/dark/icon.png", url: "https://rdstation.com.br/", description: "Parceria RD Station" },
  { name: "Meta Business Partner", logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7b/Meta_Platforms_Inc._logo.svg/1200px-Meta_Platforms_Inc._logo.svg.png", url: "https://www.facebook.com/business/partner-directory", description: "Meta Business Partner" },
  { name: "ABMI", logo: "", url: "https://abmi.org.br/", description: "Associação Brasileira de Marketing Imobiliário" },
];
